<template>
    <div>
        <b-card no-body class="mb-1">
            <b-card-header header-tag="header" class="p-1" role="tab">
                <b-button block v-b-toggle.privacy-section-9 class="text-left fw-500">9. Dispute Resolution</b-button>
            </b-card-header>
            <b-collapse id="privacy-section-9" visible accordion="my-accordion" role="tabpanel">
                <b-card-body>
                    <ol>
                        <li>Reporting Disputes: Any disputes arising from the use of the VA service should be reported to RCPAY Virtual Account’s customer support.</li>
                        <li>Resolution Process: RCPAY Virtual Account will endeavour to resolve disputes amicably and in a timely manner. If unresolved, disputes will be handled in accordance with the laws of Hong Kong.</li>
                        <li>Governing Law: These terms are governed by the laws of Hong Kong. Any legal disputes will be subject to the exclusive jurisdiction of the courts of Hong Kong.</li>
                    </ol>
                </b-card-body>
            </b-collapse>
        </b-card>
      
    </div>
</template>

<script>
  
export default {
    name: 'section-9',
    data() {
        return {
        publicPath      : process.env.BASE_URL!='/'?process.env.BASE_URL:''
        };
    }
};
</script>